import React from "react";
import Flash from "./Flash.jsx";
import Currency from "./currency.js";
import Overlay from "./Overlay.jsx";

class Payment extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      payment: null,
      flash_messages: [],
      flash_timestamp: "",
      show_refund: false,
      refunding: false
    };

    this.retrieve_payment = this.retrieve_payment.bind(this);
    this.refund_payment = this.refund_payment.bind(this);
  }

  componentDidMount(){
    this.retrieve_payment();
  }

  retrieve_payment(){
    fetch(`/payments/${this.props.id}?include=Customer,PaymentMethod`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json()).then((json) => {
      if (!json.payment){
        return Flash.add_message(this, "Error encountered in retrieving Payment.", 'danger', 5);
      }
      this.setState({payment: json.payment});
    }).catch(() => {
      Flash.add_message(this, "Error encountered in retrieving Payment.", 'danger', 5);
    });
  }

  refund_payment(){
    if (this.state.refunding){
      return;
    }

    this.setState({refunding: true});
    fetch(`/payments/${this.props.id}/refund?include=Customer,PaymentMethod`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': this.props.auth_token
      }
    }).then((response) => {
      return response.json().then((json) => ({ok: response.ok, json: json}));
    }).then(({ok, json}) => {
      if (!ok || !json.payment){
        const message = json.errors ? json.errors.join(', ') : (json.error || "Failed to refund payment.");
        this.setState({refunding: false});
        return Flash.add_message(this, message, 'danger', 5);
      }

      this.setState({
        payment: json.payment,
        show_refund: false,
        refunding: false
      });
      Flash.add_message(this, "Payment successfully refunded.", 'success', 5);
    }).catch(() => {
      this.setState({refunding: false});
      Flash.add_message(this, "Failed to refund payment.", 'danger', 5);
    });
  }

  display_value(value){
    return [null, undefined, ''].includes(value) ? '-' : value;
  }

  display_amount(payment){
    const amount = Currency.display(payment.amount, payment.currency);
    return amount === null ? this.display_value(payment.amount) : `${payment.currency.toUpperCase()} ${amount}`;
  }

  display_date(value){
    if (!value){
      return '-';
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
  }

  render(){
    const payment = this.state.payment;
    if (!payment){
      return null;
    }

    const amount = this.display_amount(payment);
    const can_refund = payment.status === 'succeeded' && !payment.refunded_at;

    return (
      <div className="psintegril-card payment-card">
        <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
        <div className="psintegril-card-header">
          <h1>{amount} on {this.display_date(payment.succeeded_at)}</h1>
        </div>

        <div className="psintegril-table-container">
          <table className="psintegril-table">
            <tbody>
              <tr><th>Amount</th><td>{amount}</td></tr>
              <tr><th>Status</th><td>{this.display_value(payment.status)}</td></tr>
              <tr><th>Customer</th><td><a href={`/s/customers/${payment.customer_id}`}>{this.display_value(payment.customer && payment.customer.name)}</a></td></tr>
              <tr><th>Invoice ID</th><td>{this.display_value(payment.invoice_id)}</td></tr>
              <tr><th>Payment method</th><td>{this.display_value(payment.payment_method && payment.payment_method.name)}</td></tr>
              <tr><th>Succeeded at</th><td>{this.display_date(payment.succeeded_at)}</td></tr>
              <tr><th>Refunded at</th><td>{this.display_date(payment.refunded_at)}</td></tr>
              <tr><th>Stripe ID</th><td>{this.display_value(payment.id_gateway)}</td></tr>
            </tbody>
          </table>
        </div>

        <div className="payment-actions">
          <button
            className="psintegril-btn psintegril-btn-danger"
            type="button"
            disabled={!can_refund}
            onClick={() => this.setState({show_refund: true})}
          >
            {payment.refunded_at || payment.status === 'refunded' ? 'Refunded' : 'Refund payment'}
          </button>
        </div>

        {this.state.show_refund ?
          <Overlay on_cancel={() => !this.state.refunding && this.setState({show_refund: false})}>
            <div className="payment-refund-overlay" role="dialog" aria-modal="true" aria-labelledby="payment-refund-title">
              <h2 id="payment-refund-title">Refund payment?</h2>
              <p>Are you sure you want to refund {amount}? This action cannot be undone.</p>
              <div className="payment-refund-actions">
                <button className="psintegril-btn psintegril-btn-secondary" type="button" disabled={this.state.refunding} onClick={() => this.setState({show_refund: false})}>
                  Cancel
                </button>
                <button className="psintegril-btn psintegril-btn-danger" type="button" disabled={this.state.refunding} onClick={this.refund_payment}>
                  {this.state.refunding ? 'Refunding…' : 'Confirm refund'}
                </button>
              </div>
            </div>
          </Overlay>
        : null}
      </div>
    );
  }
}

export default Payment;
